export const questionContinueButtonDataSet = { cy: 'question-continue-button' };
